import { render, staticRenderFns } from "./CatchLink.vue?vue&type=template&id=18b8fbe8&scoped=true&"
import script from "./CatchLink.vue?vue&type=script&lang=js&"
export * from "./CatchLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b8fbe8",
  null
  
)

export default component.exports